export const automotiveClassification = {
  "All Classes": 0,
  Primary: 4,
  Fleet: 5,
  Wholesale: 7,
  Exotic: 6,
  Classifieds: 8
} as const;

export type automotiveClassificationValues =
  (typeof automotiveClassification)[keyof typeof automotiveClassification];
export type automotiveClassificationLabels =
  keyof typeof automotiveClassification;
export const automotiveClassificationLabelsList = Object.keys(
  automotiveClassification
) as automotiveClassificationLabels[];
export const automotiveClassificationValuesList = Object.values(
  automotiveClassification
) as automotiveClassificationValues[];

export const automotiveClassificationGetValue = (
  value: automotiveClassificationLabels
): automotiveClassificationValues => {
  return automotiveClassification[value];
};

export const automotiveClassificationGetLabel = (
  value: automotiveClassificationValues
): automotiveClassificationLabels => {
  return automotiveClassificationLabelsList[
    automotiveClassificationValuesList.indexOf(value)
  ];
};
